import script from "./VersionChangeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionChangeModal.vue?vue&type=script&setup=true&lang=js"

import "./VersionChangeModal.vue?vue&type=style&index=0&id=58721f9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58721f9b"]])

export default __exports__